export function mparticleEmailFields() {
  return (
    {
      mparticle_id: window.mParticle.Identity.getCurrentUser?.()?.getMPID(),
      mparticle_device_id: window.mParticle.getDeviceId?.(),
    }
  );
}
